<template>
  <transition name="fade">
    <div
      v-if="toastStore.status"
      @click="hideToast"
      class="fixed bottom-4 left-1/2 -translate-x-1/2 z-52 inline-flex items-center bg-[#282b2d]/90 gap-2 px-[18px] py-[12px] rounded-[10px] shadow-[0px_3px_3px_rgba(0,0,0,0.3)]"
      :class="[toastStore.status ? 'active' : '']"
    >
      <svg class="shrink-0 w-5 h-auto" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="toastStore.type == 'success'">
        <path
          id="bg"
          d="M8 1C6.61553 1 5.26216 1.41054 4.11101 2.17971C2.95987 2.94888 2.06266 4.04213 1.53285 5.32122C1.00303 6.6003 0.86441 8.00776 1.13451 9.36563C1.4046 10.7235 2.07129 11.9708 3.05026 12.9497C4.02922 13.9287 5.2765 14.5954 6.63437 14.8655C7.99224 15.1356 9.3997 14.997 10.6788 14.4672C11.9579 13.9373 13.0511 13.0401 13.8203 11.889C14.5895 10.7378 15 9.38447 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1ZM7.04 10.76H6.335L4.145 8.57L4.855 7.865L6.685 9.7L11.145 5.24L11.855 5.945L7.04 10.76Z"
          fill="#489565"
        />
        <path d="M6.69002 9.69999L4.85502 7.86499L4.14502 8.56999L6.33502 10.76H7.04002L11.855 5.94499L11.145 5.23999L6.69002 9.69999Z" fill="#282b2d" />
      </svg>

      <svg class="shrink-0 w-5 h-auto" width="46" height="40" viewBox="0 0 46 40" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="toastStore.type == 'error'">
        <path
          d="M23.0014 0.259995C21.3798 0.259995 19.8814 1.12534 19.071 2.5299L1.53003 32.9308C0.719754 34.3351 0.719825 36.0649 1.53021 37.4691V37.4691C2.34112 38.8743 3.8402 39.74 5.46258 39.74H40.5595C42.1814 39.74 43.6802 38.8745 44.4909 37.4697V37.4697C45.3014 36.0652 45.3011 34.335 44.4901 32.9308L26.9307 2.52822C26.1201 1.1246 24.6223 0.259995 23.0014 0.259995V0.259995Z"
          fill="#FF7E7E"
        />
        <path
          d="M24.5 14.06C24.5 13.2316 23.8284 12.56 23 12.56V12.56C22.1716 12.56 21.5 13.2316 21.5 14.06V25.46C21.5 26.2884 22.1716 26.96 23 26.96V26.96C23.8284 26.96 24.5 26.2884 24.5 25.46V14.06Z"
          fill="#282b2d"
        />
        <path d="M23 33.34C24.1046 33.34 25 32.4446 25 31.34C25 30.2354 24.1046 29.34 23 29.34C21.8954 29.34 21 30.2354 21 31.34C21 32.4446 21.8954 33.34 23 33.34Z" fill="#282b2d" />
      </svg>

      <span class="inline-block text-base font-medium select-none">{{ toastStore.message }}</span>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { useToastStore } from '@/stores/toast'

const toastStore = useToastStore()

const hideToast = () => {
  if (toastStore.status) {
    toastStore.reset()
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
